import { render, staticRenderFns } from "./AddSettlementCommentForm.vue?vue&type=template&id=ef4d0340&"
import script from "./AddSettlementCommentForm.vue?vue&type=script&lang=js&"
export * from "./AddSettlementCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports